import Axios from "../util/axiosInstance";

export const loginApi = (payload) => {
  return Axios.post("/api/user/login", payload)
};

export const completeSplashPageLoginApi = (payload) => {
  return Axios.post("/api/SplashPage/CompleteLogin", payload)
};